/**
 * Created by Jie Gao on 2018-06-14.
 */
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {GGFreespinOutroView} from "./GGFreespinOutroView";

export class GGFreespinOutroController extends FreespinOutroController {
    private _isX2BombOutro: boolean;

    constructor(config: IScreenConfig) {
        super(config);
    }

    public start(): void {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(StageManager.stage, 0.5, {y: 0}),
            TweenLite.to(StageManager.stage, 0.5, {x: 0}),
            TweenLite.to(StageManager.stage.scale, 0.5, {x: 1, y: 1})
        ]);
        tl.add(() => {
            super.start();
        });
    }

    protected calculateIsTriggered(data: GGParsedGameData): boolean {
        if(data.brokeBank){
            return false;
        }

        const isX2BombOutro: boolean = data.wasFeatureBuy && (data.nextMode === GameMode.NORMAL);
        this._isX2BombOutro = isX2BombOutro;
        const isFSOutro: boolean = data.isFreespinMode && (data.nextMode === GameMode.NORMAL || data.nextMode === GGGameMode.DOUBLE_BOMB);
        return (isX2BombOutro || isFSOutro);
    }

    protected close(): void {
        super.close();
        (<GGFreespinOutroView>this._view).reset();
        GGGameModuleConfig.fsCounter.hideFlag(!this._isX2BombOutro);
    }

    protected onCloseComplete(): void {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => super.onCloseComplete()
        });

        if ((this._serverData as GGParsedGameData).isFreespinMode) {
            tl.add([
                GGGameModuleConfig.background.panUpDownEffect(true, false),
                ()=>GGGameModuleConfig.soundPlayer.playCameraPanningSound()
            ]);
        }
    }
}